import useGoodsDetail from "@QUERIES/prdt/goods/useGoodsDetail";
import {useEffect} from "react";

const TaggingGTM = (props: {menu: string; goodsCd: string}) => {
	const goodsDetail = useGoodsDetail(props.goodsCd).data?.body;

	useEffect(() => {
		if (!goodsDetail) return;

		try {
			dataLayer.push({
				event: "viewContent",
				ecommerce: {
					detail: {
						products: [
							{
								name: `${goodsDetail.goodsNm}`,
								id: `${props.goodsCd}`,
								category: `${props.menu}`,
							},
						],
					},
				},
			});
		} catch (e) {
			console.log(e);
		}
	}, [goodsDetail]);

	return <></>;
};

export default TaggingGTM;
